import React from "react";
import PropTypes from "prop-types";
import { UncontrolledTooltip } from "reactstrap";
import tooltipIcon from "../../../client_customizations/assets/images/icons/tooltipIcon.svg"

const ToolTip = ({ id, message }) => {
  return (
    <>
      <span id={id} style={{ display: "inline-block" }}>
        <img
          src={tooltipIcon}
          alt=""
          style={{ width: "16px", marginLeft: "5px", marginBottom: "3px" }}
        />
      </span>
      <UncontrolledTooltip placement="right" target={id}>
        <span>{message}</span>
      </UncontrolledTooltip>
    </>
  );
};

export default ToolTip;

ToolTip.propTypes = {
  id: PropTypes.string,
  message: PropTypes.string
};
